import clsx from 'clsx'
import React from 'react'

interface LaurelsTitleProps {
  largePX?: boolean
  secondary?: boolean
}

const LaurelsTitle = (props: LaurelsTitleProps) => {
  const isDark = props?.secondary ? '' : '-dark'

  return (
    <div className="flex flex-row items-center px-[7px]">
      <svg className="w-[37px] h-[72px]">
        <use href={`/svg/sprite.svg#left-leaf-new${isDark}`}></use>
      </svg>
      <div className="relative flex flex-col gap-2 grow justify-center items-center text-center">
        <h2
          className={clsx('uppercase pb-0.5', {
            ' font-[700] text-base text-darkGrayText': props?.secondary,
            ' text-base text-[#C3C3C4] font-[700]': !props?.secondary,
          })}
        >
          Cleaned over
        </h2>
        <p className="text-XL font-bold pb-0.5">50+ Million Photos</p>
      </div>
      <svg className="w-[37px] h-[72px]">
        <use href={`/svg/sprite.svg#right-leaf-new${isDark}`}></use>
      </svg>
    </div>
  )
}

export default LaurelsTitle
